import { Component, OnInit } from '@angular/core';
import { PayallService } from '../../services/payall/payall.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-payall-balance',
  templateUrl: './payall-balance.component.html',
  styleUrls: ['./payall-balance.component.scss'],
  providers: [DatePipe]
})
export class PayallBalanceComponent implements OnInit {
  balance: string = '0.00';
  loading: boolean = true;
  error: string | null = null;
  lastTransactions: any[] = [];
  showHistory: boolean = false;
  historyLoading: boolean = false;
  fullHistory: any[] = [];

  constructor(
    private payallService: PayallService,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.loadBalance();
    this.loadLastTransactions();
  }

  loadBalance(): void {
    this.loading = true;
    this.error = null;
    
    this.payallService.getBalance().subscribe({
      next: (response) => {
        if (response?.resp?.saldo_disponible) {
          this.balance = response.resp.saldo_disponible;
        }
        this.loading = false;
      },
      error: (err) => {
        this.error = 'Error al cargar el saldo';
        this.loading = false;
        console.error('Error loading balance:', err);
      }
    });
  }

  loadLastTransactions(): void {
    this.payallService.getLastTransactions().subscribe({
      next: (response) => {
        this.lastTransactions = response?.data || [];
      },
      error: (err) => {
        console.error('Error loading transactions:', err);
      }
    });
  }

  loadFullHistory(): void {
    if (this.showHistory) {
      this.historyLoading = true;
      this.payallService.getTransactionHistory().subscribe({
        next: (response) => {
          this.fullHistory = response?.data || [];
          this.historyLoading = false;
        },
        error: (err) => {
          console.error('Error loading history:', err);
          this.historyLoading = false;
        }
      });
    }
  }

  toggleHistory(): void {
    this.showHistory = !this.showHistory;
    if (this.showHistory) {
      this.loadFullHistory();
    }
  }

  formatDate(date: string): string {
    return this.datePipe.transform(date, 'dd/MM/yyyy HH:mm') || '';
  }

  refreshData(): void {
    this.loadBalance();
    this.loadLastTransactions();
    if (this.showHistory) {
      this.loadFullHistory();
    }
  }
} 